export default __webpack_public_path__ + "static/media/christian.aadaf994.jpg";